import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./App.scss";
import { selectAuth } from "./redux/features/auth/auth-slice";
import {
  selectIsShowEstimationInterruptModal,
  setIsOnCancelPressed,
  setIsOnConfirmPressed,
  setIsShowEstimationInterruptModal,
} from "./redux/features/solar-estimation/solarEstimationSlice";
import { selectTheme, setIsDarkMode } from "./redux/features/theme/theme-slice";
import { selectCountry } from "./redux/features/user/user-slice";
import CountrySelectModal from "./screens/calculate-energy/country-select-modal/country-select-modal";
import AppRoutes from "./screens/routes";
import { ESolarSimLocalStorage } from "./shared/oversight-core/enums/solar-sim-local-storage";
import { IDirectSave } from "./shared/oversight-core/interfaces/direct-save";
import { ISimplifiedSave } from "./shared/oversight-core/interfaces/simplified-save";
import { IWaterHeaterSave } from "./shared/oversight-core/interfaces/water-heater-save";
import EstimationInterruptionModal from "./shared/oversight-core/shared-components/estimation-interruption-modal/estimation-interruption-modal";
ReactGA.initialize("G-TWHCJ9L65L");

function App() {
  const auth = useSelector(selectAuth);
  const location = useLocation();
  const pathname = location.pathname;

  const [showCountrySelectModal, setShowCountrySelectModal] = useState(false);

  const country = useSelector(selectCountry);
  const theme = useSelector(selectTheme);
  const isShowEstimationInterruptionModal = useSelector(
    selectIsShowEstimationInterruptModal
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!country) {
      setShowCountrySelectModal(true);
      return;
    }

    setShowCountrySelectModal(false);
  }, [country]);

  useEffect(() => {
    if (theme === "system") {
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

      dispatch(setIsDarkMode(mediaQuery.matches));

      const handleChange = (e: MediaQueryListEvent) => {
        document.body.className = e.matches ? "dark" : "light";
        dispatch(setIsDarkMode(e.matches));
      };

      // Set initial
      document.body.className = mediaQuery.matches ? "dark" : "light";

      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    } else {
      document.body.className = theme;

      if (theme === "dark") {
        dispatch(setIsDarkMode(true));
      } else {
        dispatch(setIsDarkMode(false));
      }
    }
  }, [theme]);

  useEffect(() => {
    // if (auth.token) {
    //   if (!pathname.includes("advanced")) {
    //     localStorage.removeItem(
    //       ESolarSimLocalStorage.ESTIMATOR_DETAILS_ADVANCED
    //     );
    //   }
    //   if (!pathname.includes("simplified")) {
    //     localStorage.removeItem(
    //       ESolarSimLocalStorage.ESTIMATOR_DETAILS_SIMPLIFIED
    //     );
    //     localStorage.removeItem("simplifiedSave");
    //   }
    //   if (!pathname.includes("direct")) {
    //     localStorage.removeItem(ESolarSimLocalStorage.ESTIMATOR_DETAILS_DIRECT);
    //     localStorage.removeItem("simplifiedSave");
    //   }
    //   return;
    // }

    if (!pathname.includes("advanced")) {
      localStorage.removeItem(ESolarSimLocalStorage.ESTIMATOR_DETAILS_ADVANCED);
    }

    if (!pathname.includes("simplified")) {
      const unParsedSimplifiedSave = localStorage.getItem("simplifiedSave");

      if (unParsedSimplifiedSave) {
        const parsedSimplifiedSave: ISimplifiedSave = JSON.parse(
          unParsedSimplifiedSave
        );
        if (parsedSimplifiedSave.isCalledSave) {
          localStorage.removeItem(
            ESolarSimLocalStorage.ESTIMATOR_DETAILS_SIMPLIFIED
          );
          localStorage.removeItem("simplifiedSave");
        }
      } else {
        localStorage.removeItem(
          ESolarSimLocalStorage.ESTIMATOR_DETAILS_SIMPLIFIED
        );
      }
    }

    if (!pathname.includes("direct")) {
      const unParsedDirectSave = localStorage.getItem("directSave");

      if (unParsedDirectSave) {
        const parsedDirectSave: IDirectSave = JSON.parse(unParsedDirectSave);
        if (parsedDirectSave.isCalledSave) {
          localStorage.removeItem(
            ESolarSimLocalStorage.ESTIMATOR_DETAILS_DIRECT
          );
          localStorage.removeItem("directSave");
        }
      } else {
        localStorage.removeItem(ESolarSimLocalStorage.ESTIMATOR_DETAILS_DIRECT);
      }
    }

    if (!pathname.includes("water-heater")) {
      const unParsedWaterHeaterSave = localStorage.getItem("waterHeaterSave");

      if (unParsedWaterHeaterSave) {
        const parsedWaterHeaterSave: IWaterHeaterSave = JSON.parse(
          unParsedWaterHeaterSave
        );
        if (parsedWaterHeaterSave.isCalledSave) {
          localStorage.removeItem(
            ESolarSimLocalStorage.ESTIMATOR_DETAILS_WATER_HEATER
          );
          localStorage.removeItem("waterHeaterSave");
        }
      } else {
        localStorage.removeItem(
          ESolarSimLocalStorage.ESTIMATOR_DETAILS_WATER_HEATER
        );
      }
    }
  }, [pathname, auth.token]);

  return (
    <>
      <AppRoutes />
      <CountrySelectModal show={showCountrySelectModal} hideCancel hideClose />
      <EstimationInterruptionModal
        show={isShowEstimationInterruptionModal}
        onCancel={() => {
          dispatch(setIsShowEstimationInterruptModal(false));
          dispatch(setIsOnConfirmPressed(false));
          dispatch(setIsOnCancelPressed(true));
        }}
        onClose={() => {
          dispatch(setIsShowEstimationInterruptModal(false));
          dispatch(setIsOnConfirmPressed(false));
          dispatch(setIsOnCancelPressed(true));
        }}
        onConfirm={() => {
          dispatch(setIsOnConfirmPressed(true));
        }}
      />
    </>
  );
}

export default App;
